import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MessageSquareWarning } from 'lucide-react';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                <MessageSquareWarning size={100} color="#666" style={{ marginBottom: 16 }} />
                <Typography component="h1" variant="h2" gutterBottom>
                    404
                </Typography>
                <Typography variant="h5" color="text.secondary" paragraph>
                    Page Not Found
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </Typography>
                <Button
                    variant="contained"
                    fullWidth
                    onClick={() => navigate('/dashboard')}
                    sx={{ mt: 3, mb: 2 }}
                >
                    Go to Dashboard
                </Button>
            </Box>
        </Container>
    );
};

export default NotFoundPage;
